<!--Pick Normal Login Page or SU Login Page (Set up this way because of routing)-->
<div *ngIf="LoginInit == false" class="LoadingDiv">
	<i class="pi-spin pi pi-spinner" style="font-size: 45px; margin-bottom: 15px"></i>
</div>
<caass-normal-login *ngIf="LoginInit == true && SuLoginEnabled == false" [CAASS_VERSION]="CAASS_VERSION" [ErrorB64]="ErrorB64"></caass-normal-login>
<caass-su-login *ngIf="LoginInit == true && SuLoginEnabled == true" [CAASS_VERSION]="CAASS_VERSION"></caass-su-login>
